import { Box, Button, Divider, FormControl, FormLabel, Switch, Typography } from "@mui/joy";
import React, { Fragment, useState } from "react";
import { serverHost } from "./const";

const FogForestView: React.FC = () => {
  const [systemOpen, setSystemOpen] = useState<boolean>(false);
  const [cmdState, setCmdState] = useState<{ [key: string]: boolean[] }>({
    up: new Array<boolean>(8).fill(false),
    mid: new Array<boolean>(7).fill(false),
    down: new Array<boolean>(10).fill(false),
  });

  let allopen = {
    up: new Array<boolean>(8).fill(true),
    mid: new Array<boolean>(7).fill(true),
    down: new Array<boolean>(10).fill(true),
  };
  let allclose = {
    up: new Array<boolean>(8).fill(false),
    mid: new Array<boolean>(7).fill(false),
    down: new Array<boolean>(10).fill(false),
  };
  const systemCmd = async (open: boolean) => {
    let cmdMap = open ? CmdOpenMap : CmdCloseMap;

    for (let part in CmdNameMap) {
      let cmdArray = [];
      for (let i = 1; i <= CmdNameMap[part].length; i++) {
        cmdArray.push(cmdMap[i]);
      }
      let action: string = `fog_${part}_` + cmdArray.join("_");

      let url = `http://${serverHost}/control?action=${action}`;

      try {
        const resp: Response = await fetch(url, {
          method: "POST",
        });
        if (!resp.ok) {
          console.log(await resp.text());
          alert("发送命令失败");
          setSystemOpen(!open);
          return;
        } else {
          setSystemOpen(open);
          if (open) {
            setCmdState(allopen);
          } else {
            setCmdState(allclose);
          }
        }
      } catch (error) {
        console.log(error);
        alert("发送命令失败");
        setSystemOpen(!open);
        return;
      }
      alert("发送命令成功");
    }
  };

  const sendCmd = async (checked: boolean, num: number, part: string, cmd: string) => {
    let action: string = `fog_${part}_${cmd}`;

    const url = `http://${serverHost}/control?action=${action}`;

    let state = { ...cmdState };

    try {
      const resp: Response = await fetch(url, {
        method: "POST",
      });
      if (!resp.ok) {
        console.log(await resp.text());
        alert("发送命令失败");
        state[part][num - 1] = !checked;
        setCmdState(state);
        return;
      } else {
        alert("发送命令成功");
        state[part][num - 1] = checked;
        setCmdState(state);
      }
    } catch (error) {
      console.log(error);
      alert("发送命令失败");
      state[part][num - 1] = !checked;
      setCmdState(state);
      return;
    }
  };

  const generateCmdList = (part: string) => {
    let ret = [];
    for (let i = 0; i < CmdNameMap[part].length; i++) {
      ret.push(
        <FogSwitchBtn
          cmdName={CmdNameMap[part][i]}
          key={`${part}_${i + 1}`}
          checked={cmdState[part][i]}
          num={i + 1}
          part={part}
          onClick={sendCmd}></FogSwitchBtn>
      );
    }
    return ret;
  };

  return (
    <Fragment>
      <Typography level='h1' sx={{ display: "flex", justifyContent: "center" }}>
        岱山县蓬莱森林体育公园工程远程中央控制系统
      </Typography>
      <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <FormControl orientation='horizontal' sx={{ width: "50%" }}>
          <FormLabel>
            <Typography level='h3' fontSize='xl' sx={{ mb: 0.5 }}>
              系统开关
            </Typography>
          </FormLabel>
          {/* <Switch
            checked={systemOpen}
            size='lg'
            onChange={(e) => {
              systemCmd(e.target.checked);
            }}></Switch> */}
            <Box sx={{ display: "flex", alignItems: "center", marginLeft: "auto"}}>
              <Button onClick={() => {
                systemCmd(true);
              }}> 打 开 </Button>
              <Divider orientation='vertical' sx={{ mx: 1 }} />
              <Button onClick={ () => {
                systemCmd(false);
              }}> 关 闭 </Button>
            </Box>
        </FormControl>
      </Box>
      <Divider>
        <Typography level='h2' fontSize='xl' sx={{ mb: 0.5 }}>
          义火禅寺
        </Typography>
      </Divider>
      {generateCmdList("up")}
      <Divider>
        <Typography level='h2' fontSize='xl' sx={{ mb: 0.5 }}>
          高显庙
        </Typography>
      </Divider>
      {generateCmdList("mid")}
      <Divider>
        <Typography level='h2' fontSize='xl' sx={{ mb: 0.5 }}>
          玻璃暖房
        </Typography>
      </Divider>
      {generateCmdList("down")}
    </Fragment>
  );
};

const CmdNameMap: { [key: string]: string[] } = {
  up: [
    "蓬莱仙径 1",
    "蓬莱仙径 右上",
    "木平台竹林",
    "蓬莱仙径 左上",
    "蓬莱仙径 3",
    "蓬莱仙径 4",
    "蓬莱仙径 5",
    "蓬莱仙径 2",
  ],
  mid: ["廊桥雾森右(备用)", "铁廊桥水系右", "廊桥雾森左", "铁廊桥水系左", "水库左", "广场水系", "水库折桥"],
  down: [
    "水库右边",
    "暖房",
    "暖房假山",
    "铁廊桥树林",
    "叠翠谷右",
    "叠翠谷左",
    "竹林",
    "铁廊桥圆草坪",
    "铁廊桥1段",
    "铁廊桥2段(备用)",
  ],
};

const CmdOpenMap: { [key: number]: string } = {
  1: "CCDDA10100010001A448",
  2: "CCDDA10100020002A64C",
  3: "CCDDA10100040004AA54",
  4: "CCDDA10100080008B264",
  5: "CCDDA10100100010C284",
  6: "CCDDA10100200020E2C4",
  7: "CCDDA101004000402244",
  8: "CCDDA10100800080A244",
  9: "CCDDA10101000100A448",
  10: "CCDDA10102000200A64C",
  11: "CCDDA10104000400AA54",
  12: "CCDDA10108000800B264",
  13: "CCDDA10110001000C284",
  14: "CCDDA10120002000E2C4",
  15: "CCDDA101400040002244",
  16: "CCDDA10180008000A244",
};

const CmdCloseMap: { [key: number]: string } = {
  1: "CCDDA10100000001A346",
  2: "CCDDA10100000002A448",
  3: "CCDDA10100000004A64C",
  4: "CCDDA10100000008AA54",
  5: "CCDDA10100000010B264",
  6: "CCDDA10100000020C284",
  7: "CCDDA10100000040E2C4",
  8: "CCDDA101000000802244",
  9: "CCDDA10100000100A346",
  10: "CCDDA10100000200A448",
  11: "CCDDA10100000400A64C",
  12: "CCDDA10100000800AA54",
  13: "CCDDA10100001000B264",
  14: "CCDDA10100002000C284",
  15: "CCDDA10100004000E2C4",
  16: "CCDDA101000080002244",
};

const FogSwitchBtn: React.FC<{
  cmdName: string;
  checked: boolean;
  num: number;
  part: string;
  onClick: (checked: boolean, num: number, part: string, cmd: string) => void;
}> = ({ cmdName, checked, num, part, onClick }) => {
  return (
    <Fragment>
      <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <FormControl orientation='horizontal' sx={{ width: "50%" }}>
          <FormLabel>
            <Typography level='h3' fontSize='xl' sx={{ mb: 0.5 }}>
              {cmdName}
            </Typography>
          </FormLabel>
          <Switch
            checked={checked}
            size='lg'
            onChange={(e) => {
              console.log("here");
              let cmd = e.target.checked ? CmdOpenMap[num] : CmdCloseMap[num];
              onClick(e.target.checked, num, part, cmd);
            }}></Switch>
        </FormControl>
      </Box>
    </Fragment>
  );
};

export default FogForestView;
